/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    BottleBatchCreationRequestDto,
    BottleBatchDto,
    BottleBatchUpdateRequestDto,
    BottleGroupDto,
    BottleGroupUpdateRequestDto,
    BottleSizeDto,
    FileTransferDto,
    ImageInfoDto,
    PageBottleBatchDto,
    PageBottleGroupDto,
    ReadyForMarketBottleGroupDataDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class BottleBatchControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addBottleGroup(
                    bottleBatchId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: BottleGroupUpdateRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        bottleGroupStatusTransitions(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    manualChange?: boolean,
                    userLegalEntityId?: number
                }
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}/status/allowedTransitions`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        changeBottleBatchStatus(
                    bottleBatchId: number
                , 
                queryParams: {
                    status: string,
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/status`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        createBottleBatch(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: BottleBatchCreationRequestDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        deleteBottleBatch(
                    bottleBatchId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        deleteBottleGroup(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        getAllBottleBatches(
                
                queryParams: {
                    ids?: Array<number>,
                    titleLike?: string,
                    statuses?: Array<string>,
                    wineryId?: number,
                    userLegalEntityId?: number
                }
    ): Observable<Array<BottleBatchDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/all`;

            return this._httpClient.get<Array<BottleBatchDto>>(url, requestOptions);
    }


        getBottleBatch(
                    bottleBatchId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<BottleBatchDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}`;

            return this._httpClient.get<BottleBatchDto>(url, requestOptions);
    }


        getBottleBatchImages(
                    bottleBatchId: number,
                    imageId: number
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/images/${imageId}`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getBottleBatchImagesDto(
                    bottleBatchId: number,
                    imageId: number
    ): Observable<FileTransferDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/images/${imageId}/dto`;

            return this._httpClient.get<FileTransferDto>(url, requestOptions);
    }


        getBottleBatchImagesInfos(
                    bottleBatchId: number
    ): Observable<Array<ImageInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/images`;

            return this._httpClient.get<Array<ImageInfoDto>>(url, requestOptions);
    }


        getBottleBatchStatusTransitions(
                    bottleBatchId: number
                , 
                queryParams: {
                    manualChange?: boolean,
                    userLegalEntityId?: number
                }
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/status/allowedTransitions`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getBottleBatchesPage(
                
                queryParams: {
                    ids?: Array<number>,
                    titleLike?: string,
                    statuses?: Array<string>,
                    wineryId?: number,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageBottleBatchDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/page`;

            return this._httpClient.get<PageBottleBatchDto>(url, requestOptions);
    }


        getBottleGroup(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<BottleGroupDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}`;

            return this._httpClient.get<BottleGroupDto>(url, requestOptions);
    }


        getBottleGroupById(
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<BottleGroupDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/bottlegroup/${bottleGroupId}`;

            return this._httpClient.get<BottleGroupDto>(url, requestOptions);
    }


        getBottleGroups(
                    wineryId: number
                , 
                queryParams: {
                    status?: string
                }
    ): Observable<Array<BottleGroupDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/wineries/${wineryId}/bottlegroups`;

            return this._httpClient.get<Array<BottleGroupDto>>(url, requestOptions);
    }


        getBottleGroupsPage(
                
                queryParams: {
                    titleLike?: string,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageBottleGroupDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/bottlegroup/page`;

            return this._httpClient.get<PageBottleGroupDto>(url, requestOptions);
    }


        getBottleSizes(
                
                queryParams: {
                    ids?: Array<string>
                }
    ): Observable<Array<BottleSizeDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/sizes`;

            return this._httpClient.get<Array<BottleSizeDto>>(url, requestOptions);
    }


        isBottleBatchEditable(
                    bottleBatchId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/editable`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        isBottleGroupEditable(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}/isEditable`;

            return this._httpClient.get<boolean>(url, requestOptions);
    }


        markBottleGroupLabellingInProgress(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}/status/labellingInProgress`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        markBottleGroupReadyForMarket(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: ReadyForMarketBottleGroupDataDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}/status/readyForMarket`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        updateBottleBatch(
                    bottleBatchId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: BottleBatchUpdateRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


        updateBottleGroup(
                    bottleBatchId: number,
                    bottleGroupId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: BottleGroupUpdateRequestDto
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/bottlebatch/${bottleBatchId}/bottlegroup/${bottleGroupId}`;

            return this._httpClient.put<boolean>(url, requestBody, requestOptions);
    }


}

